export var Apptus = {
  NotifyClick: function (ticket) {
    Beacon({
      vars: { type: "click", ticket: ticket }
    });
  },

  NotifyClickById: function (identifier) {
    Beacon({
      vars: { type: "click", identifier: identifier }
    });
  },

  NotifyAddToCart: function (ticket) {
    Beacon({
      vars: { type: "adding_to_cart", ticket: ticket }
    });
  },

  NotifyVote: function (postId, newRating) {
    Beacon({
      vars: { identifier: postId, rating: newRating, type: "rating" }
    });
  }
}

var Beacon = function (opts) {
  opts = opts || {};
  opts.url = opts.url || '/api/Apptus/Notification';
  opts.vars = opts.vars || {};
  opts.error = opts.error || function () { return false; };
  opts.success = opts.success || function () { return true; };

  // Split up vars object into an array
  var varsArray = [];
  for (var key in opts.vars) { varsArray.push(key + '=' + opts.vars[key]); }
  // Build query string
  var qString = varsArray.join('&');

  // Create a beacon if a url is provided
  if (opts.url) {
    // Create a brand NEW image object
    var beacon = new Image();
    // Attach the event handlers to the image object
    if (beacon.onerror) { beacon.onerror = opts.error; }
    if (beacon.onload) { beacon.onload = opts.success; }

    // Attach the src for the script call
    beacon.src = opts.url + '?' + qString;
  }
}